module.exports = __webpack_public_path__ + "oldminecraftwpa2e06c6faa08f3acbe842eefd813cc86.png";